<template>
  <div class="image-element">
    <button
      v-if="allowDownload"
      class="image-download"
      :aria-label="t('message.media.downloadimage')"
      @click="downloadImage"
    >
      <IconDownloadFile />
    </button>

    <img :src="src" :alt="alt" :class="{ 'rounded': !notRounded }" :style="{ 'aspect-ratio': aspectRatio || 'auto' }" />
  </div>
</template>

<script setup lang="ts">
import { saveAs } from 'file-saver';
import IconDownloadFile from '@/svg/IconDownloadFile.vue';
import { useI18n } from '@/composables/useI18n';

const { t } = useI18n();


const props = defineProps<{
  src: string;
  alt?: string;
  aspectRatio?: string;
  allowDownload?: boolean;
  notRounded?: boolean;
}>();

const downloadImage = () => {
  // TODO fix filename
  saveAs(props.src, 'image');
};
</script>

<style scoped lang="scss">
.image-element {
  position: relative;

  img {
    display: block;
    max-width: 100%;
    width: 100%;
    height: 100%;
    max-height: 340px;
    object-fit: cover;

    display: block;
  }

  .rounded {
    border-radius: var(--kw-widget-global-borderradius-outer);
  }
}

.image-download {
  position: absolute;
  top: 4px;
  left: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  background-color: rgb(0, 0, 0, .6);
  border-radius: 6px;
  padding: 4px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  backdrop-filter: blur(4px);

  &:hover {
    background-color: rgb(0, 0, 0, 1);
  }
}
</style>
